export function kebabToCapital(text: string): string {
  // Split the string by hyphens and capitalize each word
  const words = text.split('-');
  const capitalizedWords = words.map((word) => word.charAt(0).toUpperCase() + word.slice(1));

  // Join the words back together
  return capitalizedWords.join('');
}

export function getValueByPartialKey<T>(
  obj: Record<string, T>,
  searchString: string,
): T | undefined {
  const key = Object.keys(obj).find((key) => key.includes(searchString));
  return key ? obj[key] : undefined;
}

export function decodeHtmlEntities(text: string): string {
  const element = document.createElement('div');
  element.innerHTML = text;
  return element.textContent || '';
}

type ProcessRichTextOptions = {
  colors?: {
    main?: string;
    highlight?: string;
    accent?: string;
  };
  vars?: Record<string, string>;
};

export const processRichText = (text: string, options: ProcessRichTextOptions = {}): string => {
  const { colors = {}, vars = {} } = options;
  let result = text
    .replace(
      /<mainText>(.*?)<\/mainText>/g,
      (_, content) => `<span style="color: ${colors.main ?? ''};">${content}</span>`,
    )
    .replace(
      /<highlight>(.*?)<\/highlight>/g,
      (_, content) => `<span style="color: ${colors.highlight ?? ''};">${content}</span>`,
    )
    .replace(
      /<accentText>(.*?)<\/accentText>/g,
      (_, content) => `<span style="color: ${colors.accent ?? ''};">${content}</span>`,
    )
    .replace(
      /<bold>(.*?)<\/bold>/g,
      (_, content) => `<span style="font-weight: 500;">${content}</span>`,
    )
    .replace(
      /<strong>([\s\S]*?)<\/strong>/g,
      (_, content) => `<span style="font-weight: 500;">${content}</span>`,
    );

  for (const [key, value] of Object.entries(vars)) {
    result = result.replace(new RegExp(`{{\\s*${key}\\s*}}`, 'gi'), value);
  }
  return result;
};
